<script setup lang="ts">
import { useSlots } from 'vue';

import { Label } from '@/components/ui/label';
import BaseInput, { type InputType } from '@components/atoms/BaseInput.vue';

interface Props {
  label: string;
  type?: InputType;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
  required?: boolean;
  optional?: boolean;
  id?: string;
  maxlength?: number;
}

const props = withDefaults(defineProps<Props>(), {
  type: 'text',
  placeholder: '',
  disabled: false,
  error: '',
  required: false,
  optional: false,
  id: '',
  maxlength: undefined,
});

const model = defineModel<string>({ default: '' });

const slots = useSlots();
const hasDefaultSlot = !!slots['default'];

const inputId = props.id || `field-${Math.random().toString(36).substring(2, 9)}`;
</script>

<template>
  <div class="w-full">
    <Label :for="inputId" class="mb-1.5">
      {{ label }}
      <span v-if="required" class="text-destructive">*</span>
    </Label>
    <slot v-if="hasDefaultSlot" />
    <BaseInput
      v-else
      :id="inputId"
      v-model="model"
      :type="type"
      :placeholder="placeholder"
      :disabled="disabled"
      :error="error"
      :maxlength="maxlength"
    />
  </div>
</template>
